module.exports = __webpack_public_path__ + "img/05_Farmland Classification.18388381.png";